module.exports = __webpack_public_path__ + "static/img/6-2.e6b6a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-2.png
// module id = 3b6e
// module chunks = 25